import { MedicalTerm } from '../../../lib/types/models/medical-terms/medical-term'
import { MedicalTermInput } from '../../../lib/types/models/medical-terms/medical-term-input'

export const mapMedicalTermIntoInput = (medicalTerm: MedicalTerm): MedicalTermInput => {
  return {
    label: medicalTerm.label,
    value: medicalTerm.value,
    level: medicalTerm.level
  }
}
